import { useEffect } from 'react';

/**
 * RouteWrapper: Ensures scroll to top when this component mounts
 * This provides a backup scroll mechanism for individual routes
 */
const RouteWrapper = ({ children }) => {
  useEffect(() => {
    console.log('[RouteWrapper] Component mounted, scrolling to top');
    window.scrollTo(0, 0);
    
    // Additional fallback
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }, []);

  return children;
};

export default RouteWrapper;
